import React from "react";
import {Col, Row} from "react-bootstrap";
import styles from "./AdminPreview.module.css";
import LoaderGraph from "../../general/LoaderGraph";

const AdminSiteResponse = (props) => {
    // sd = site data
    const sd = Array.isArray(props.dataResponse) ? props.dataResponse : {};

    const formatResult = (result) => {
        if (result === undefined || result === null) return "";
        if (typeof result === "string") return result;
        if (typeof result !== "object") return `${result}`;

        return Object.entries(result)
            .map(([k, v]) => `${k}: ${typeof v === "object" && v !== null ? JSON.stringify(v) : v}`)
            .join("\n");
    };

    const getExecutableStatements = (sqlText) => {
        if (typeof sqlText !== "string") return [];

        return sqlText
            .split(";")
            .map((statement, index) => ({
                index,
                text: statement.trim(),
            }))
            .filter(({text}) => {
                if (!text) return false;

                const normalized = text.toUpperCase();
                return normalized !== "START TRANSACTION" && normalized !== "COMMIT" && normalized !== "ROLLBACK";
            });
    };

    const renderSqlRow = (sql, res, key) => (
        <Row key={key} style={{marginBottom: "10px"}}>
            <Col sm={8}><pre style={{margin: 0, whiteSpace: "pre-wrap"}}>{sql}</pre></Col>
            <Col sm={4}><pre style={{margin: 0, whiteSpace: "pre-wrap"}}>{res}</pre></Col>
        </Row>
    );

    const rowRendered = (data) => {
        if (data.error !== undefined) {
            return [renderSqlRow(data.sql || "", data.sqlMessage || data.error || "", `error-${data.sql || "unknown"}`)];
        }

        const sqlText = Array.isArray(data) ? data[0] : "";
        const rawResult = Array.isArray(data) ? data[1] : null;
        const statements = getExecutableStatements(sqlText);

        if (!Array.isArray(rawResult)) {
            const sql = statements[0]?.text || sqlText;
            const res = rawResult?.note !== undefined ? rawResult.note : formatResult(rawResult);
            return [renderSqlRow(sql, res, `single-${sql}`)];
        }

        const renderedRows = statements.map(({index, text}, rowIndex) => {
            const resultText = formatResult(rawResult[index]);
            return renderSqlRow(text, resultText, `${index}-${rowIndex}-${text}`);
        });

        return renderedRows.length > 0
            ? renderedRows
            : [renderSqlRow(sqlText, formatResult(rawResult), `fallback-${sqlText}`)];
    };

    const rows = Array.isArray(sd)
        ? sd.flatMap((item) => rowRendered(item))
        : [];

    return (
        <div className={`form-contents ${styles.adminPreview}`}>
            {Array.isArray(sd) && sd.length > 0 ? (
                <div>
                    <Row>
                        <Col sm="11"></Col>
                        <Col sm="1">
                            <span
                                onClick={() => props.closed()}
                                style={{float: "right", cursor: "pointer"}}
                                className="glyphicon glyphicon-remove close-approval"
                            ></span>
                        </Col>
                    </Row>
                    {rows.length > 0 && rows.map((v) => v)}
                </div>
            ) : (
                <LoaderGraph />
            )}

            <div className="btn-container">
                <Row>
                    <Col md="3"></Col>
                    <Col md="3">
                        <button
                            className="btn btn-primary btn-generate btn-approval"
                            title="Close"
                            onClick={() => props.closed()}
                        >
                            <span>Close</span>
                        </button>
                    </Col>
                    <Col md="3"></Col>
                </Row>
            </div>
        </div>
    );
};

export default AdminSiteResponse;
